import Create from '../../../base/errors/user/Create';

const create: Create = {
  GeneralError: 'Error occurred while processing the request, please try again. If the problem persists contact Calypso group with error code <{trackingId}>.',
  DuplicateUserName: 'Username already exists',
  UnableToSetNotificationChannel: 'User created successfully, however notification channel could not be set. Try again later.'
};

export default create;
